import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService, regexPattern } from 'src/app/services/common.service';

@Component({
  selector: 'app-uploaddoc',
  templateUrl: './uploaddoc.component.html',
  styleUrls: ['./uploaddoc.component.scss']
})
export class UploaddocComponent implements OnInit {
  formdataCreate: FormGroup;
  documenttypedropdown: any = [];
  documenttypedropdown1: any = [];
  visibilityList: any = [];
  visibilityList1: any = [];
  visibityvaluefromdocumenttype: any
  showLoader: boolean = false

  @Output() newItemEvent = new EventEmitter<any>();

  constructor(private fb: FormBuilder, private commonServ: CommonService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.formdataCreate = this.fb.group({
      document_type: [''],
      visibility_type: [''],
      document_name: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9 ]*')]),
      version: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9. ]*')]),
      description: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9 ]*')]),
      tenantspecificFlag: new FormControl(false),
      attachmentFileName: [''],
      tenantName: ['']



    })
    this.getdocuemnttype();
    this.getdocumentvisbility();
    this.fetchtenant();
  }

  onBack(e) {
    let value = {
      homepage: true,
      definedoctype: false,
      uploaddoc: false
    };
    this.newItemEvent.emit(value);
  }
  file: File
  fileName: any
  onFileChange(event) {
    console.log("event", event)
    this.file = event.srcElement.files[0];
    var fileFormat = this.file.name.substr(this.file.name.lastIndexOf("."));
    var filename = event.srcElement.files[0].name.split(".")[0]
    console.log("filename", filename)
    this.fileName = event.srcElement.files[0].name
    var fileExt = event.srcElement.files[0].name.split(".")[1]
    var fileSize = event.srcElement.files[0].size / 1024;

    var allowedTypes = ["txt", "doc", "docx", "pdf", "xls", "xlsx", "xlsb", "zip", "7z", "jpg", "jpeg", "odt", "ods", "csv"]
    // const specialChars = /[,'~@\\\\}{+)(*^%$£\"!\\|<>+]/;

    // if ($.inArray(fileExt.toLowerCase(), allowedTypes) !== -1 && fileSize > 0) {
    if (fileSize > 2000) {
      // if (this.page.create) {
      this.formdataCreate.controls['attachmentFileName'].setErrors({ size: true });
      // } else if (this.page.edit) {
      //   this.formdataEdit.controls['attachmentFileName'].setErrors({ size: true });
      // }
      // this._snackBar.open("File size exceeded. Maximum allowed size is 2 MB.", "Close")
    }
    // else if (specialChars.test(filename)) {
    else {
      if (regexPattern.alphanumericWithUnderscoreAndHyphen.test(filename)) {

      } else {
        // if (this.page.create) {
        this.formdataCreate.controls['attachmentFileName'].setErrors({ specialCharacters: true })
        // } else if (this.page.edit) {
        // this.formdataEdit.controls['attachmentFileName'].setErrors({ specialCharacters: true })
        // }
      }
    }
    // }
    // else {
    //   // if (this.page.create) {
    //     this.formdataCreate.controls['attachmentFileName'].setErrors({ format: true });
    //   // } else if (this.page.edit) {
    //   //   this.formdataEdit.controls['attachmentFileName'].setErrors({ format: true });
    //   // }

    // }
  }

  get f() {

    return this.formdataCreate.controls;

  }

  getdocuemnttype() {
    this.commonServ.fetchDocumentType().subscribe((response) => {
      console.log(response)
      this.documenttypedropdown = response;
      this.documenttypedropdown1 = this.documenttypedropdown.slice()
    })
  }
  getdocumentvisbility() {
    this.commonServ.fetchDocumentVisibility().subscribe((response) => {
      console.log(response)
      this.visibilityList = response;
      this.visibilityList1 = this.visibilityList.slice();

    })
  }

  uploadnewdoc(event) {
    console.log("event", event)
    this.showLoader = true
    event['fileName'] = this.fileName;

    console.log(this.file)

    this.commonServ.uploaddoc(event, this.file).subscribe((response) => {


      let value = {
        homepage: true,
        definedoctype: false,
        uploaddoc: false
      };
      this.newItemEvent.emit(value);
    })
    this.showLoader = false;
  }

  tenantenableflag: boolean = false
  selectdocumenttype(event) {
    console.log("event", event)

    this.commonServ.fetchVisibility(event).subscribe((response) => {
      console.log("response", response)
      this.visibityvaluefromdocumenttype = response[0]['visibility']
      if (this.visibityvaluefromdocumenttype == 'Private') {
        this.tenantenableflag = true;
      } else {
        this.tenantenableflag = false;
      }
    })
  }

  tenantfieldflag: boolean = false
  tenattanenable(event) {
    console.log(event.checked)
    if (this.visibityvaluefromdocumenttype == 'Private') {
      if (event.checked) {
        this.tenantfieldflag = true
      } else {
        this.tenantfieldflag = false
      }
    } else {
      this._snackBar.open('Can not make public document as Tenant Specific', "Close", {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
      });
    }
  }
  tenantList: any = [];
  tenantList1: any = [];
  fetchtenant() {
    this.commonServ.fetchtenant().subscribe((response) => {
      console.log(response)
      this.tenantList = response;
      this.tenantList1 = this.tenantList.slice();

    })
  }

}
